import { ZfBox, ZfFormField, ZfIcon, ZfPopover, ZfSlider, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useGeneralSimulationSettings } from '../../../hooks/useGeneralSimulationSettings';

export const ProjectionPeriodSlider: FunctionComponent = () => {
    const { t } = useTranslation();
    const { settings, patchSettings } = useGeneralSimulationSettings();

    const onProjectionPeriodChange = (event: CustomEvent<number>) => patchSettings({ projectionPeriodYears: event.detail });

    return settings?.projectionPeriodYears ? (
        <ZfBox style={{ minWidth: 0, flex: 1, display: 'flex', flexDirection: 'column', padding: 'var(--padding-horizontal-md) var(--padding-horizontal-xs)' }}>
            <ZfFormField label={t('projectionPeriod')}>
                <ZfSlider
                    valueLabel={` ${t('years')}`}
                    value={settings?.projectionPeriodYears}
                    min={15}
                    max={100}
                    onValueChangeCommitted={onProjectionPeriodChange}
                    scalePosition="bottom"
                >
                    <ZfTypography slot="start" variant="label-tiny" color="normal">
                        15 {t('years')}
                    </ZfTypography>
                    <ZfTypography slot="end" variant="label-tiny" color="normal">
                        100 {t('years')}
                    </ZfTypography>
                </ZfSlider>
                <ZfPopover slot="label-trailing" alignment="start">
                    <ZfIcon slot="anchor" size="medium" name="info" style={{ cursor: 'pointer' }} />
                    <ZfTypography variant="label-extra-small" color="normal">
                        {t('projectionPeriodInfoBox')}
                    </ZfTypography>
                </ZfPopover>
            </ZfFormField>
        </ZfBox>
    ) : null;
};
